export default {
  // 页面标题和描述
  title: '为您的业务打造极致的 AI 体验',
  description: '只需提供几条信息，我们就能为您打造专属的业务解决方案',
  
  // 表单字段标签
  formLabels: {
    name: '姓名',
    firstName: '名',
    lastName: '姓',
    email: '工作邮箱',
    website: '公司网站（URL）',
    budget: '您的每月达人营销预算',
    industry: '您的所属行业',
    goal: '本次活动目标',
    location: '组织所在地',
    phone: '手机号',
    wechat: '微信',
    contact: '联系方式',
    linkedin: 'LinkedIn',
    note: '有助于准备会议的任何信息（可选）'
  },
  
  // 表单占位符
  placeholders: {
    name: '请输入您的全名',
    firstName: '例如：Alex',
    lastName: '例如：Johnson',
    email: '例如：alex.johnson@company.com',
    website: '例如：www.yourcompany.com',
    budget: '选择预算区间',
    industry: '选择所属行业',
    goal: '选择活动目标',
    country: '选择国家/地区',
    phone: '请输入手机号',
    code: '验证码',
    wechat: '请输入微信号',
    contact: 'LinkedIn / WhatsApp / Line / Telegram / Slack',
    linkedin: '请输入 LinkedIn 主页链接',
    note: '您想让我们了解的任何信息…'
  },
  
  // 表单验证消息
  validation: {
    nameRequired: '请输入您的姓名',
    firstNameRequired: '请输入名',
    lastNameRequired: '请输入姓',
    emailRequired: '请输入您的工作邮箱',
    emailInvalid: '请输入有效的工作邮箱',
    websiteRequired: '请输入您的公司网站',
    websiteInvalid: '请输入有效的网站 URL',
    budgetRequired: '请选择营销预算',
    budgetTooLow: 'AhaCreator 适用于 2,000 美元或以上的预算。一旦 AhaCreator Lite 支持较小预算，我们会立即联系您。',
    industryRequired: '请选择所属行业',
    goalRequired: '请选择活动目标',
    countryRequired: '请选择国家/地区',
    phoneRequired: '请输入手机号',
    phoneInvalid: '手机号格式不正确',
    codeRequired: '请输入验证码',
    codeLength: '验证码须为 6 位数字',
    codeIncorrect: '请输入正确的验证码',
    wechatRequired: '请输入微信号',
    contactRequired: '请输入您的联系方式'
  },
  
  // 按钮文本
  buttons: {
    sendCode: '发送验证码',
    resend: '重新发送',
    resendCountdown: '重新发送 {countdown}s',
    submit: '提交',
    chooseDateTime: '选择日期和时间',
    loading: '加载中…',
    continue: '继续'
  },
  
  // 其他文本
  required: '*',
  source: '平台',
  
  // 预算选项
  budgetOptions: {
    lessThan2000: '少于 2,000 USD / 月',
    '2000To10000': '2,000 - 10,000 USD / 月',
    '10000To50000': '10,000 - 50,000 USD / 月',
    moreThan50000: '超过 50,000 USD / 月'
  },
  
  // 行业选项
  industryOptions: {
    aiSaaSApp: 'AI / SaaS / App',
    ecommerce: '电商',
    agency: '广告公司或代理商（聚焦 AI / SaaS / App / 电商）',
    beauty: '美妆',
    foodBeverage: '餐饮',
    others: '其他'
  },
  
  // 活动目标选项
  campaignGoalOptions: {
    brandAwareness: '品牌曝光',
    brandAwarenessAndPerformance: '品牌曝光 + 效果转化',
    performanceOnly: '销售（暂不适合 AhaCreator）'
  }
};
